import { render, staticRenderFns } from "./DropResourceOnResourceModal.vue?vue&type=template&id=36faac2a"
import script from "./DropResourceOnResourceModal.vue?vue&type=script&lang=js"
export * from "./DropResourceOnResourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports